/**
 * 주석 관련 유틸리티 함수
 */
import { Annotation } from '../../../types/book';
import { ApiPageComponent } from '../../../services/bookService';

/**
 * bookUid를 bookId로 변환하는 헬퍼 함수 (간단한 해시)
 */
export const bookUidToId = (bookUid: string): number => {
  let hash = 0;
  for (let i = 0; i < bookUid.length; i++) {
    const char = bookUid.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

/**
 * component_no를 실제 paragraphId(component.id)로 매핑하는 헬퍼 함수
 */
export const mapAnnotationsParagraphId = (
  annotations: Annotation[],
  components: ApiPageComponent[]
): Annotation[] => {
  return annotations.map(annotation => {
    // paragraphId가 "component-{number}" 형태인 경우 실제 component.id로 변환
    const match = annotation.range.paragraphId.match(/^component-(\d+)$/);
    if (match) {
      const componentNo = parseInt(match[1], 10);
      // component_no로 먼저 찾고, 없으면 index로 폴백 (하위 호환성)
      const component =
        components.find(c => c.component_no === componentNo) ||
        components.find(c => c.index === componentNo);
      if (component) {
        return {
          ...annotation,
          range: {
            ...annotation.range,
            paragraphId: component.id,
          },
        };
      }
    }
    return annotation;
  });
};

/**
 * 녹음 시간 포맷 (MM:SS)
 */
export const formatRecordingTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

